import { PropsWithChildren } from "react";
import cn from "classnames";
import { useImpersonationRestriction } from "hooks/use-impersonation-restriction";

type ImpersonationAwareContainerProps = {
  classNames?: string;
}

export const ImpersonationAwareContainer = ({ children, classNames = '' }: PropsWithChildren<ImpersonationAwareContainerProps>) => {
  const { shouldRestrict } = useImpersonationRestriction();

  return <div inert={shouldRestrict ? true : undefined} className={cn(classNames)}>{children}</div>;
}
